export enum certificateElementCapability {
  dimensionable = 1,
  alignable = 2,
  backgroundColorable = 3,
  dynamicImageable = 4,
  pageable= 5,
  transformAble = 6,
  dynamicListable = 7,
  opacityAble =8,
  draggable = 9,
  resizeable= 10,
  moveDestroyable = 11,
  containerAble= 12,
  layoutAble= 13,
  sizeable = 14,
  rotateable = 15,
  fillable =16,
  imageable = 17,
  wysiwygable = 18,
  relativelyAlignable = 19,
  widthable = 20,
  repeatable = 21,
  paddingable = 22,
  marginable = 23,
  outlineThicknessable = 24,
  lineable = 25,
  mergeable = 26,
  labelable = 27,
  previewable = 28,
  pageSizeable = 29,
  layoutDraggable = 30,
  pageMarginable = 31,
  nonDisplayLayoutable = 32,
  pageNumberable = 33,

}
